interface SVGRProps {
    title?: string;
    titleId?: string;
}

const OutlookCalendarIcon: React.VFC<React.SVGProps<SVGSVGElement> & SVGRProps> = ({
    title,
    titleId,
    ...props
}) => {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 43 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M42.995 19.847c0 .06-.008.118-.024.175a.356.356 0 01-.02.081c.003.003 0 .007-.004.01a.297.297 0 01-.027.07.695.695 0 01-.05.102.843.843 0 01-.359.353l-1.57.88-.135.078-1.671.935-.386.215-7.28 4.09-.141.08-2.774 1.557-.345.192-.342.192-.173.097c-.057.03-.118.064-.179.098l-.017.01a1.592 1.592 0 01-.396.144H27.1a1.987 1.987 0 01-.51.064 2.034 2.034 0 01-.915-.208c-.047-.027-.095-.054-.142-.078a.77.77 0 00-.054-.03l-2.172-1.22-.294-.166-.21-.117-.044-.024-.159-.09-.024-.014-.07-.04-.052-.03-.054-.03-.067-.038-.081-.044-.041-.023-.01-.007-.108-.06-.095-.054-.027-.014-.122-.067-6.132-3.443-1.292-.727-.386-.215-1.672-.935-.177-.1-1.526-.858a.859.859 0 01-.358-.353.738.738 0 01-.051-.105l-.071-.333a.885.885 0 01.45-.773l.01-.01c.007 0 .013-.007.02-.007l1.526-.854.18-.1 7.216-4.053.467-.262 1.797-1.006.121-.07.027-.014.095-.054.109-.06.01-.007.04-.024.081-.043.068-.037.054-.03.05-.027.072-.04.024-.014.159-.091.043-.024.21-.117.295-.168 2.171-1.218c.068-.037.132-.074.197-.107a2.067 2.067 0 011.823 0c.068.033.132.07.196.107l3.633 2.038 2.26 1.268 7.219 4.052.135.078 1.57.877c.01 0 .017.007.024.007l.007.01a.889.889 0 01.453.773z"
                fill="#123B6D"
            />
            <path
                d="M31.488 5.044h-9.48v8.743l9.48 8.744h9.48v-8.744l-9.48-8.743z"
                fill="#28A8EA"
            />
            <path
                d="M31.488 22.531v8.743h-9.48l-.17-.14-.023-.021v-.003l-.03-.027-.061-.05-.116-.098-.01-.007-.149-.128-.003-.003-.037-.03-.017-.014-.017-.017-.2-.168h-.003l-.041-.037-.027-.023-.017-.014-.04-.034-.102-.084-.203-.164-8.215-6.676-.338-.275v-9.473h9.819l.203.188.05.047.15.138.105.094.095.087.159.148.044.04.21.196 8.464 7.805z"
                fill="#0364B8"
            />
            <path d="M22.008 22.53h-9.48v8.744h9.48v-8.743z" fill="#14447D" />
            <path d="M40.968 22.53h-9.48v8.744h9.48v-8.743z" fill="#0078D4" />
            <path d="M40.968 5.044h-9.48v8.743h9.48V5.044z" fill="#50D9FF" />
            <path
                d="M22.008 5.044h-9.819v8.743h9.819V5.044zM31.488 13.788h-9.48v8.743h9.48v-8.743z"
                fill="#0078D4"
            />
            <path
                d="M14.01 0h25.137a1.832 1.832 0 011.288.53 1.808 1.808 0 01.533 1.28v3.234H12.19V1.81a1.8 1.8 0 01.534-1.28A1.821 1.821 0 0114.01 0z"
                fill="#0358A7"
            />
            <path
                opacity={0.1}
                d="M40.968 20.12L27.067 27.61l-.065.038a.666.666 0 01-.145.067l-.453-.253-.057-.03a.93.93 0 01-.08-.043l-.034-.021-2.753-1.52-.225-.126-.185-.1-.406-.228-10.475-5.784V30.46h28.78V20.12z"
                fill="#0A2767"
            />
            <path
                opacity={0.1}
                d="M40.968 20.456l-13.901 7.492-.065.037a.646.646 0 01-.145.067l-.453-.252-.057-.03a.903.903 0 01-.08-.044l-.034-.02-2.753-1.52-.225-.127-.185-.1-.406-.227-10.475-5.784v10.848h28.78v-10.34z"
                fill="#0A2767"
            />
            <path
                opacity={0.1}
                d="M40.968 20.792l-13.901 7.492-.065.038a.666.666 0 01-.145.067l-.453-.253-.057-.03a.93.93 0 01-.08-.043l-.034-.021-2.753-1.52-.225-.126-.185-.101-.406-.227-10.475-5.784v10.848h28.78v-10.34z"
                fill="#0A2767"
            />
            <path
                opacity={0.1}
                d="M40.968 21.128L27.067 28.62l-.065.038a.666.666 0 01-.145.067l-.453-.253-.057-.03a.958.958 0 01-.08-.043l-.034-.021-2.753-1.52-.225-.126-.185-.101-.406-.227-10.475-5.784v10.848h28.78v-10.34z"
                fill="#0A2767"
            />
            <path
                d="M42.54 20.595l-.018.01-.005.002-14.83 7.992a2.156 2.156 0 01-2.023.107 2.102 2.102 0 01-.199-.107l.698 4.983 14.782 4.387c.43.002.852-.127 1.206-.37a1.916 1.916 0 00.847-1.57v-16.18a.852.852 0 01-.458.746z"
                fill="#1490DF"
            />
            <path
                opacity={0.05}
                d="M28.265 28.303l-.552.297a2.154 2.154 0 01-2.023.107 2.124 2.124 0 01-.199-.107l.698 4.983 14.782 4.387c.43.002.852-.127 1.207-.37.394-.267.675-.669.792-1.128l-14.705-8.17z"
                fill="#000"
            />
            <path
                opacity={0.05}
                d="M42.857 36.793l-14.945-8.3-.199.107a2.154 2.154 0 01-2.023.107 2.124 2.124 0 01-.199-.108l.698 4.984 14.782 4.387c.43.002.852-.127 1.207-.37a1.97 1.97 0 00.68-.807z"
                fill="#000"
            />
            <path
                opacity={0.05}
                d="M42.691 37.087l-15.128-8.402-.049.023a2.154 2.154 0 01-1.824 0 2.124 2.124 0 01-.199-.107l.698 4.983 14.782 4.388c.43.001.852-.128 1.207-.37.201-.14.375-.314.513-.515z"
                fill="#000"
            />
            <path
                opacity={0.05}
                d="M42.473 37.35l-15.19-8.438-.076-.04-.06-.033a2.158 2.158 0 01-1.457-.133 2.114 2.114 0 01-.2-.107l.699 4.983L40.97 37.97c.43.002.852-.128 1.207-.37.106-.074.205-.157.295-.25z"
                fill="#000"
            />
            <path
                d="M42.198 37.583c-.044.03-.088.06-.133.088-.043.027-.09.05-.138.074-.054.027-.109.05-.163.074l-.01.003a2.896 2.896 0 01-.183.06 1.13 1.13 0 01-.21.051 1.223 1.223 0 01-.163.023c-.072.01-.146.015-.22.014H12.24a2.047 2.047 0 01-1.446-.575 2.023 2.023 0 01-.613-1.423V19.848l.468.259.006.003c.004.003.004.003.007.003l1.527.844 2.85 1.574 6.969 3.847.203.115.05.027.15.084.105.057.095.05.159.091.044.024.21.114 2.519 1.392c.064.04.132.077.2.111l.84.467.53.296h.004l2.258 1.255.607.336.606.336.253.142.353.195 11.004 6.113z"
                fill="#28A8EA"
            />
            <path
                opacity={0.05}
                d="M23.024 9.752v20.05a1.784 1.784 0 01-.593 1.331 1.772 1.772 0 01-.521.336 1.832 1.832 0 01-.708.141H10.157v-1.345h.024V19.847a.884.884 0 01.45-.773l.01-.01c.007 0 .014-.007.021-.007l1.527-.854V7.734h9.013c.285.002.564.082.806.232a2.15 2.15 0 011.016 1.786z"
                fill="#000"
            />
            <path
                opacity={0.075}
                d="M22.77 9.786v19.68c.001.352-.1.698-.291.995a1.603 1.603 0 01-.285.336 1.147 1.147 0 01-.186.151c-.07.053-.145.098-.224.135-.034.02-.067.034-.101.05a1.803 1.803 0 01-.704.142H10.158v-1.01h.023V19.849a.884.884 0 01.45-.774l.01-.01c.007 0 .014-.007.021-.007l1.527-.854V7.82h8.76a1.68 1.68 0 011.059.393 2.07 2.07 0 01.762 1.574z"
                fill="#000"
            />
            <path
                opacity={0.1}
                d="M22.516 9.816V29.13c.005.478-.177.938-.508 1.285a.665.665 0 01-.05.047 1.664 1.664 0 01-.499.336c-.003 0-.006.003-.01.003a1.794 1.794 0 01-.69.138H10.158v-.672h.023V19.848a.884.884 0 01.45-.774l.01-.01c.007 0 .014-.007.021-.007l1.527-.854v-10.3h8.505a1.774 1.774 0 011.314.612c.324.357.504.82.508 1.301z"
                fill="#000"
            />
            <path
                opacity={0.125}
                d="M22.262 9.846v18.947c.002.338-.086.67-.254.965-.177.31-.448.556-.775.703-.041.016-.085.033-.13.047a1.734 1.734 0 01-.565.094h-10.38v-.336h.023V19.848a.884.884 0 01.45-.774l.01-.01c.007 0 .014-.007.021-.007l1.527-.854V7.987h8.251a1.828 1.828 0 011.568.928c.166.283.254.604.254.931z"
                fill="#000"
            />
            <path
                opacity={0.2}
                d="M22.008 9.88v18.576c.02.392-.095.779-.325 1.098-.23.318-.562.55-.941.658-.14.037-.283.055-.427.053H10.18V19.848a.883.883 0 01.45-.773l.01-.01c.007 0 .014-.007.02-.007l1.528-.854V8.071h7.997c.483 0 .947.19 1.288.53.342.34.534.8.534 1.279z"
                fill="#000"
            />
            <path
                d="M20.186 8.07H1.822C.816 8.07 0 8.88 0 9.88v18.24c0 1 .816 1.81 1.822 1.81h18.364c1.006 0 1.822-.81 1.822-1.81V9.88c0-1-.816-1.81-1.822-1.81z"
                fill="url(#prefix__paint0_linear)"
            />
            <path
                d="M6.108 16.021a4.934 4.934 0 011.945-2.133c.94-.534 2.009-.8 3.09-.769a5.5 5.5 0 012.86.73 4.885 4.885 0 011.892 2.038c.456.934.683 1.961.663 2.998a6.907 6.907 0 01-.682 3.138 5.003 5.003 0 01-1.95 2.11 5.714 5.714 0 01-2.966.749 5.63 5.63 0 01-2.923-.738 4.959 4.959 0 01-1.916-2.042 6.384 6.384 0 01-.67-2.963 7.083 7.083 0 01.657-3.118zm2.073 5.01a3.198 3.198 0 001.094 1.403c.5.348 1.099.527 1.709.512.65.025 1.29-.16 1.825-.528a3.065 3.065 0 001.062-1.408 5.407 5.407 0 00.339-1.959 5.923 5.923 0 00-.32-1.984 3.143 3.143 0 00-1.024-1.458 2.84 2.84 0 00-1.809-.555 2.966 2.966 0 00-1.75.516c-.5.357-.888.848-1.117 1.415a5.584 5.584 0 00-.008 4.046H8.18z"
                fill="#fff"
            />
            <defs>
                <linearGradient
                    id="prefix__paint0_linear"
                    x1={3.821}
                    y1={6.644}
                    x2={18.04}
                    y2={31.44}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop />
                    <stop offset={0.5} />
                    <stop offset={1} />
                </linearGradient>
                <clipPath id="prefix__clip0">
                    <path fill="#fff" d="M0 0h43v38H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default OutlookCalendarIcon;
